import React from 'react';

type OwnProps = {
  className?: string;
};

const ReferralsNavIcon = ({ className }: OwnProps) => (
  <svg
    className={className}
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.325 0.767456C14.6978 0.767456 15 1.06966 15 1.44246V11.8796C15 12.2521 14.6983 12.5541 14.3258 12.5546L6.87447 12.5638L4.18654 14.9951L4.14446 12.5638L0.673365 12.5554C0.301212 12.5545 0 12.2525 0 11.8804V1.44246C0 1.06966 0.302208 0.767456 0.675 0.767456H14.325ZM9.85758 4.08584C10.5625 4.7834 10.5912 5.94591 9.92111 6.67796L7.49453 9.17053L4.95303 6.8055C4.24845 6.10729 4.22036 4.94478 4.8895 4.21273C5.21417 3.85776 5.65185 3.65604 6.12338 3.64433C6.58916 3.63229 7.03354 3.80831 7.37354 4.14017C8.04427 3.41755 9.1562 3.3912 9.85758 4.08584Z"
    />
  </svg>
);

export default ReferralsNavIcon;
